import { Popover, PopoverContent, PopoverTrigger } from "../components/ui/popover";
import { Circle } from "lucide-react";

export function ProvidersPill({ providers, health }) {
  const list = providers?.order || [];
  const configured = list.filter((p) => p.configured).length;
  const total = list.length || 6;
  const healthy = configured > 0;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid="providers-pill"
          className="flex items-center gap-2 px-3 py-1.5 border border-soft bg-surface hover:bg-surface-raised transition-colors font-mono-tight uppercase text-xs tracking-widest"
        >
          <span
            className={`relative inline-flex w-2 h-2 rounded-full ${
              healthy ? "bg-[var(--positive)]" : "bg-[var(--negative)]"
            }`}
            aria-hidden
          >
            <span
              className={`absolute inset-0 rounded-full animate-ping opacity-60 ${
                healthy ? "bg-[var(--positive)]" : "bg-[var(--negative)]"
              }`}
            />
          </span>
          <span className="text-[var(--text-primary)]">
            {configured}
            <span className="text-muted-soft">/{total}</span>
          </span>
          <span className="text-muted-soft hidden sm:inline ml-1">Providers</span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-72 p-0 bg-surface border-soft rounded-none"
        align="end"
        data-testid="providers-popover"
      >
        <div className="border-b border-soft px-4 py-3">
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-soft">
            Provider Chain
          </p>
          <p className="num text-sm text-[var(--text-primary)] mt-1">
            {configured} of {total} configured
          </p>
          {health ? (
            <p className="num text-[11px] text-muted-soft mt-1">
              cache:{" "}
              <span className="text-[var(--text-primary)]">
                {health.cache?.live_entries ?? 0}
              </span>{" "}
              live /{" "}
              <span className="text-[var(--text-primary)]">
                {health.cache?.total_entries ?? 0}
              </span>{" "}
              total
            </p>
          ) : null}
        </div>
        <ul className="py-2">
          {list.map((p, idx) => (
            <li
              key={p.name}
              className="flex items-center justify-between px-4 py-2 text-xs"
              data-testid={`provider-row-${p.name}`}
            >
              <span className="flex items-center gap-2 min-w-0">
                <span className="num text-muted-soft w-5">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <span className="text-[var(--text-primary)] truncate">
                  {p.display_name}
                </span>
              </span>
              <span
                className={`flex items-center gap-1.5 ${
                  p.configured ? "text-positive" : "text-muted-soft"
                }`}
              >
                <Circle
                  size={7}
                  fill="currentColor"
                  strokeWidth={0}
                />
                <span className="uppercase tracking-widest font-mono-tight">
                  {p.configured ? "Live" : "Idle"}
                </span>
              </span>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
